var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transition', {
    attrs: {
      "name": "alert"
    }
  }, [_vm.show ? _c('div', {
    staticClass: "capusta_alert",
    attrs: {
      "data-type": "alert"
    }
  }, [_c('div', {
    class: ['alert', _vm.getClass]
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.$t(_vm.text)))])])])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }